import { TemplateCategory } from "./types";

export const civeisCategory: TemplateCategory = {
  id: 'civeis',
  name: 'Cíveis',
  emoji: '🏛️',
  description: 'Documentos de direito civil',
  subcategories: [
    {
      id: 'acoes-civeis',
      name: 'Ações Cíveis',
      emoji: '⚖️',
      templates: [
        {
          id: 'acao-cobranca',
          name: 'Ação de cobrança',
          type: 'Ação',
          description: 'Cobrança de dívida líquida e certa',
          icon: 'DollarSign',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA [VARA] VARA CÍVEL DE [CIDADE]

[NOME DO AUTOR], [QUALIFICAÇÃO], vem perante Vossa Excelência propor a presente

contra [NOME DO RÉU], [QUALIFICAÇÃO], pelos fundamentos de fato e de direito a seguir expostos:

I - DOS FATOS
[RELATO DOS FATOS]

II - DO DIREITO
[FUNDAMENTAÇÃO JURÍDICA]

III - DO PEDIDO
Ante o exposto, requer:
a) A citação do réu
b) A condenação ao pagamento de R$ [VALOR]
c) Juros e correção monetária
d) Custas e honorários advocatícios

Dá-se à causa o valor de R$ [VALOR].

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-indenizacao',
          name: 'Ação de indenização por danos morais',
          type: 'Ação',
          description: 'Indenização por danos morais',
          icon: 'Heart',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO AUTOR] vem propor ação indenizatória contra [NOME DO RÉU]:

DOS FATOS:
[DESCRIÇÃO DETALHADA DOS FATOS]

DOS DANOS MORAIS:
[FUNDAMENTAÇÃO DOS DANOS]

DO VALOR DA INDENIZAÇÃO:
Considerando a gravidade do dano e a capacidade econômica das partes, pleiteia-se indenização no valor de R$ [VALOR].

DOS PEDIDOS:
a) Condenação ao pagamento de danos morais
b) Juros e correção monetária
c) Custas e honorários

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-despejo',
          name: 'Ação de despejo',
          type: 'Ação',
          description: 'Despejo por falta de pagamento',
          icon: 'Home',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO LOCADOR] vem propor ação de despejo contra [NOME DO LOCATÁRIO]:

DO CONTRATO:
Data: [DATA]
Imóvel: [ENDEREÇO]
Valor do aluguel: R$ [VALOR]

DA INADIMPLÊNCIA:
Período em atraso: [PERÍODO]
Valor devido: R$ [VALOR]

PEDIDOS:
a) Despejo do imóvel
b) Condenação ao pagamento dos aluguéis
c) Multa contratual
d) Custas e honorários

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-usucapiao',
          name: 'Ação de usucapião',
          type: 'Ação',
          description: 'Usucapião de bem imóvel',
          icon: 'MapPin',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO AUTOR] vem propor ação de usucapião:

DO IMÓVEL:
Localização: [ENDEREÇO]
Área: [METRAGEM]
Confrontações: [DESCRIÇÃO]

DA POSSE:
Início: [DATA]
Tempo: [ANOS] anos
Características: mansa, pacífica, contínua e com animus domini

PEDIDOS:
a) Declaração do domínio por usucapião
b) Registro no CRI
c) Expedição de mandado

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-divorcio',
          name: 'Ação de divórcio consensual',
          type: 'Ação',
          description: 'Divórcio com acordo entre as partes',
          icon: 'Users',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA VARA DE FAMÍLIA

[NOME DOS REQUERENTES] vêm propor ação de divórcio consensual:

DO CASAMENTO:
Data: [DATA]
Local: [LOCAL]
Regime de bens: [REGIME]

DOS FILHOS:
( ) Não há filhos menores
( ) Filhos: [NOMES E IDADES]

DO ACORDO:
1. Partilha de bens: [DESCRIÇÃO]
2. Guarda dos filhos: [ACORDO]
3. Pensão alimentícia: R$ [VALOR]

PEDIDOS:
a) Decretação do divórcio
b) Homologação do acordo
c) Partilha dos bens

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-alimentos',
          name: 'Ação de alimentos',
          type: 'Ação',
          description: 'Fixação de pensão alimentícia',
          icon: 'Baby',
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA VARA DE FAMÍLIA

[NOME DO AUTOR/REPRESENTANTE] vem propor ação de alimentos contra [NOME DO RÉU]:

DA RELAÇÃO DE PARENTESCO:
[DESCRIÇÃO DO PARENTESCO]

DA NECESSIDADE:
[DESCRIÇÃO DAS NECESSIDADES]

DA POSSIBILIDADE DO ALIMENTANTE:
Renda: R$ [VALOR]
Profissão: [PROFISSÃO]

VALOR PLEITEADO: [PERCENTUAL]% do salário mínimo

PEDIDOS:
a) Fixação de alimentos provisórios
b) Fixação definitiva de alimentos
c) Desconto em folha

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-guarda',
          name: 'Ação de guarda',
          type: 'Ação',
          description: 'Regulamentação de guarda de menor',
          icon: 'Shield',
          content: `AÇÃO DE REGULAMENTAÇÃO DE GUARDA

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA VARA DE FAMÍLIA

[NOME DO REQUERENTE] vem requerer a regulamentação de guarda de [NOME DO MENOR]:

DO MENOR:
Nome: [NOME]
Idade: [IDADE]
Filiação: [NOMES DOS PAIS]

DA SITUAÇÃO ATUAL:
[DESCRIÇÃO DA SITUAÇÃO]

DO MELHOR INTERESSE:
[FUNDAMENTAÇÃO]

TIPO DE GUARDA PRETENDIDA:
( ) Guarda unilateral
( ) Guarda compartilhada

PEDIDOS:
a) Concessão da guarda
b) Fixação de visitas
c) Regulamentação do regime

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-revisional-alimentos',
          name: 'Ação revisional de alimentos',
          type: 'Ação',
          description: 'Revisão de valor de pensão alimentícia',
          icon: 'RefreshCw',
          content: `AÇÃO REVISIONAL DE ALIMENTOS

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA VARA DE FAMÍLIA

[NOME DO REQUERENTE] vem propor ação revisional de alimentos:

DA DECISÃO ANTERIOR:
Processo: [NÚMERO]
Valor atual: R$ [VALOR]
Data da fixação: [DATA]

DA ALTERAÇÃO FÁTICA:
[DESCRIÇÃO DAS MUDANÇAS]

NOVO VALOR PLEITEADO: R$ [VALOR]

PEDIDOS:
a) Revisão do valor dos alimentos
b) Citação do requerido
c) Procedência da ação

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-investigacao-paternidade',
          name: 'Ação de investigação de paternidade',
          type: 'Ação',
          description: 'Reconhecimento de paternidade',
          icon: 'UserCheck',
          content: `AÇÃO DE INVESTIGAÇÃO DE PATERNIDADE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA VARA DE FAMÍLIA

[NOME DO MENOR], representado por [NOME DA MÃE], vem propor ação de investigação de paternidade contra [NOME DO SUPOSTO PAI]:

DO MENOR:
Nome: [NOME]
Data de nascimento: [DATA]
Filiação materna: [NOME DA MÃE]

DA RELAÇÃO:
[DESCRIÇÃO DO RELACIONAMENTO]

DAS PROVAS:
[RELAÇÃO DAS PROVAS]

PEDIDOS:
a) Exame de DNA
b) Reconhecimento da paternidade
c) Averbação no registro
d) Fixação de alimentos

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-exoneracao-alimentos',
          name: 'Ação de exoneração de alimentos',
          type: 'Ação',
          description: 'Pedido de dispensa de pensão alimentícia',
          icon: 'X',
          content: `AÇÃO DE EXONERAÇÃO DE ALIMENTOS

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA VARA DE FAMÍLIA

[NOME DO ALIMENTANTE] vem propor ação de exoneração de pensão alimentícia:

DA OBRIGAÇÃO ATUAL:
Beneficiário: [NOME]
Valor: R$ [VALOR]
Origem: [PROCESSO/ACORDO]

MOTIVO DA EXONERAÇÃO:
( ) Maioridade do alimentando
( ) Capacidade do alimentando
( ) Impossibilidade do alimentante
( ) Cessação da necessidade

FUNDAMENTAÇÃO:
[DESCRIÇÃO DOS MOTIVOS]

PEDIDOS:
a) Exoneração da obrigação alimentar
b) Cessação dos descontos
c) Procedência da ação

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-consignacao-pagamento',
          name: 'Ação de consignação em pagamento',
          type: 'Ação',
          description: 'Consignação de valor devido',
          icon: 'CreditCard',
          content: `AÇÃO DE CONSIGNAÇÃO EM PAGAMENTO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO AUTOR] vem propor ação de consignação em pagamento contra [NOME DO RÉU]:

DA OBRIGAÇÃO:
Origem: [DESCRIÇÃO]
Valor: R$ [VALOR]
Vencimento: [DATA]

DA RECUSA/IMPEDIMENTO:
[MOTIVO DA CONSIGNAÇÃO]

DO DEPÓSITO:
Valor consignado: R$ [VALOR]
Data: [DATA]

PEDIDOS:
a) Citação do réu
b) Declaração de quitação
c) Liberação do depósito

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-busca-apreensao',
          name: 'Ação de busca e apreensão',
          type: 'Ação',
          description: 'Busca e apreensão de bem móvel',
          icon: 'Search',
          content: `AÇÃO DE BUSCA E APREENSÃO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO AUTOR] vem propor ação de busca e apreensão contra [NOME DO RÉU]:

DO BEM:
Descrição: [DESCRIÇÃO DO BEM]
Localização: [ONDE SE ENCONTRA]
Valor: R$ [VALOR]

DO DIREITO:
[FUNDAMENTAÇÃO DO DIREITO SOBRE O BEM]

DA URGÊNCIA:
[JUSTIFICATIVA DA MEDIDA]

PEDIDOS:
a) Liminar de busca e apreensão
b) Citação do réu
c) Apreensão definitiva

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-anulacao-negocio',
          name: 'Ação anulatória de negócio jurídico',
          type: 'Ação',
          description: 'Anulação de contrato por vício',
          icon: 'Ban',
          content: `AÇÃO ANULATÓRIA DE NEGÓCIO JURÍDICO

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO AUTOR] vem propor ação anulatória contra [NOME DO RÉU]:

DO NEGÓCIO JURÍDICO:
Tipo: [CONTRATO/ACORDO]
Data: [DATA]
Objeto: [DESCRIÇÃO]

DO VÍCIO:
( ) Erro
( ) Dolo
( ) Lesão
( ) Estado de perigo
( ) Coação

FUNDAMENTAÇÃO:
[DESCRIÇÃO DO VÍCIO]

PEDIDOS:
a) Anulação do negócio jurídico
b) Restituição das partes ao estado anterior
c) Indenização por perdas e danos

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acao-reintegracao-posse',
          name: 'Ação de reintegração de posse',
          type: 'Ação',
          description: 'Reintegração na posse de bem',
          icon: 'Home',
          content: `AÇÃO DE REINTEGRAÇÃO DE POSSE

EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO

[NOME DO AUTOR] vem propor ação de reintegração de posse contra [NOME DO RÉU]:

DO BEM:
Descrição: [DESCRIÇÃO]
Localização: [ENDEREÇO]
Valor: R$ [VALOR]

DA POSSE:
Início: [DATA]
Características: [DESCRIÇÃO DA POSSE]

DO ESBULHO:
Data: [DATA]
Forma: [COMO OCORREU]

PEDIDOS:
a) Liminar de reintegração
b) Reintegração definitiva
c) Perdas e danos

Nestes termos, pede dferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        }
      ]
    },
    {
      id: 'contratos-civeis',
      name: 'Contratos Cíveis',
      emoji: '📋',
      templates: [
        {
          id: 'contrato-compra-venda',
          name: 'Contrato de compra e venda',
          type: 'Contrato',
          description: 'Compra e venda de bem móvel',
          icon: 'ShoppingCart',
          content: `CONTRATO DE COMPRA E VENDA

VENDEDOR: [NOME], [QUALIFICAÇÃO]
COMPRADOR: [NOME], [QUALIFICAÇÃO]

OBJETO: [DESCRIÇÃO DO BEM]

CLÁUSULAS:

1ª - PREÇO: R$ [VALOR]
2ª - PAGAMENTO: [FORMA DE PAGAMENTO]
3ª - ENTREGA: [DATA E LOCAL]
4ª - GARANTIA: [PRAZO E CONDIÇÕES]

DISPOSIÇÕES GERAIS:
[CLÁUSULAS ESPECÍFICAS]

[LOCAL], [DATA]

_________________________________     _________________________________
VENDEDOR                              COMPRADOR

TESTEMUNHAS:
1. [NOME]
2. [NOME]`
        },
        {
          id: 'contrato-locacao',
          name: 'Contrato de locação residencial',
          type: 'Contrato',
          description: 'Locação de imóvel residencial',
          icon: 'Home',
          content: `CONTRATO DE LOCAÇÃO RESIDENCIAL

LOCADOR: [NOME], [QUALIFICAÇÃO]
LOCATÁRIO: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [ENDEREÇO COMPLETO]

CLÁUSULAS:

1ª - PRAZO: [PRAZO] ([INÍCIO] a [FIM])
2ª - ALUGUEL: R$ [VALOR] mensais
3ª - VENCIMENTO: Todo dia [DIA]
4ª - DEPÓSITO: R$ [VALOR]
5ª - FINALIDADE: Residencial
6ª - BENFEITORIAS: [CONDIÇÕES]
7ª - RESCISÃO: [CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
LOCADOR                               LOCATÁRIO

FIADOR: _________________________________
[NOME DO FIADOR]`
        },
        {
          id: 'procuracao-geral',
          name: 'Procuração geral',
          type: 'Procuração',
          description: 'Procuração com poderes gerais',
          icon: 'FileText',
          content: `PROCURAÇÃO

OUTORGANTE: [NOME], [QUALIFICAÇÃO]
OUTORGADO: [NOME], [QUALIFICAÇÃO]

PODERES:

Pelo presente instrumento, o OUTORGANTE nomeia e constitui seu bastante procurador o OUTORGADO, a quem confere amplos poderes para:

- Representá-lo em repartições públicas
- Assinar documentos em geral
- Movimentar contas bancárias
- Comprar, vender e permutar bens
- Contratar e ser contratado
- Transigir, desistir e acordar
- Substabelecer os presentes poderes

Esta procuração é válida até [DATA] ou revogação expressa.

[LOCAL], [DATA]

_________________________________
[NOME DO OUTORGANTE]

ACEITE:
_________________________________
[NOME DO OUTORGADO]`
        },
        {
          id: 'contrato-prestacao-servicos',
          name: 'Contrato de prestação de serviços',
          type: 'Contrato',
          description: 'Prestação de serviços profissionais',
          icon: 'Briefcase',
          content: `CONTRATO DE PRESTAÇÃO DE SERVIÇOS

CONTRATANTE: [NOME], [QUALIFICAÇÃO]
CONTRATADO: [NOME], [QUALIFICAÇÃO]

OBJETO: [DESCRIÇÃO DOS SERVIÇOS]

CLÁUSULAS:

1ª - SERVIÇOS: [DETALHAMENTO]
2ª - PRAZO: [PRAZO DE EXECUÇÃO]
3ª - VALOR: R$ [VALOR]
4ª - PAGAMENTO: [FORMA E PRAZO]
5ª - RESPONSABILIDADES: [DESCRIÇÃO]
6ª - RESCISÃO: [CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
CONTRATANTE                           CONTRATADO`
        },
        {
          id: 'escritura-doacao',
          name: 'Escritura de doação',
          type: 'Escritura',
          description: 'Doação de bem imóvel',
          icon: 'Gift',
          content: `ESCRITURA PÚBLICA DE DOAÇÃO

DOADOR: [NOME], [QUALIFICAÇÃO]
DONATÁRIO: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [DESCRIÇÃO COMPLETA]

CLÁUSULAS:

1ª - O DOADOR é legítimo proprietário do imóvel
2ª - A doação é pura e simples
3ª - O DONATÁRIO aceita a doação
4ª - Ficam transferidos todos os direitos
5ª - As despesas correm por conta do DONATÁRIO

[LOCAL], [DATA]

_________________________________
DOADOR

_________________________________
DONATÁRIO

TABELIÃO: [NOME]`
        },
        {
          id: 'contrato-locacao-comercial',
          name: 'Contrato de locação comercial',
          type: 'Contrato',
          description: 'Locação de imóvel para fins comerciais',
          icon: 'Building',
          content: `CONTRATO DE LOCAÇÃO COMERCIAL

LOCADOR: [NOME], [QUALIFICAÇÃO]
LOCATÁRIO: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [ENDEREÇO COMPLETO]

CLÁUSULAS:

1ª - FINALIDADE: Comercial - [TIPO DE ATIVIDADE]
2ª - PRAZO: [PRAZO] anos
3ª - ALUGUEL: R$ [VALOR] mensais
4ª - REAJUSTE: [ÍNDICE E PERIODICIDADE]
5ª - GARANTIA: [TIPO DE GARANTIA]
6ª - DIREITO DE RENOVAÇÃO: [SIM/NÃO]

[LOCAL], [DATA]

_________________________________     _________________________________
LOCADOR                               LOCATÁRIO`
        },
        {
          id: 'contrato-comodato',
          name: 'Contrato de comodato',
          type: 'Contrato',
          description: 'Empréstimo gratuito de bem',
          icon: 'HandHeart',
          content: `CONTRATO DE COMODATO

COMODANTE: [NOME], [QUALIFICAÇÃO]
COMODATÁRIO: [NOME], [QUALIFICAÇÃO]

BEM EMPRESTADO: [DESCRIÇÃO]

CLÁUSULAS:

1ª - OBJETO: Empréstimo gratuito do bem descrito
2ª - PRAZO: [PRAZO] ou [POR TEMPO INDETERMINADO]
3ª - FINALIDADE: [USO PERMITIDO]
4ª - CONSERVAÇÃO: Por conta do comodatário
5ª - RESTITUIÇÃO: [CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
COMODANTE                             COMODATÁRIO`
        },
        {
          id: 'contrato-mutuo',
          name: 'Contrato de mútuo',
          type: 'Contrato',
          description: 'Empréstimo de dinheiro',
          icon: 'DollarSign',
          content: `CONTRATO DE MÚTUO

MUTUANTE: [NOME], [QUALIFICAÇÃO]
MUTUÁRIO: [NOME], [QUALIFICAÇÃO]

VALOR: R$ [VALOR]

CLÁUSULAS:

1ª - VALOR EMPRESTADO: R$ [VALOR]
2ª - JUROS: [TAXA]% ao mês
3ª - PRAZO: [PRAZO PARA PAGAMENTO]
4ª - PAGAMENTO: [FORMA DE PAGAMENTO]
5ª - GARANTIA: [TIPO DE GARANTIA]
6ª - MORA: [MULTA E JUROS DE MORA]

[LOCAL], [DATA]

_________________________________     _________________________________
MUTUANTE                              MUTUÁRIO`
        },
        {
          id: 'contrato-parceria',
          name: 'Contrato de parceria',
          type: 'Contrato',
          description: 'Parceria comercial entre pessoas',
          icon: 'Handshake',
          content: `CONTRATO DE PARCERIA

PARCEIRO 1: [NOME], [QUALIFICAÇÃO]
PARCEIRO 2: [NOME], [QUALIFICAÇÃO]

OBJETO: [DESCRIÇÃO DA PARCERIA]

CLÁUSULAS:

1ª - ATIVIDADE: [DESCRIÇÃO DA ATIVIDADE]
2ª - CONTRIBUIÇÃO: [PARTICIPAÇÃO DE CADA PARCEIRO]
3ª - DIVISÃO DE LUCROS: [PERCENTUAL]
4ª - ADMINISTRAÇÃO: [RESPONSABILIDADES]
5ª - DURAÇÃO: [PRAZO]
6ª - RESCISÃO: [CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
PARCEIRO 1                            PARCEIRO 2`
        },
        {
          id: 'contrato-seguro',
          name: 'Contrato de seguro',
          type: 'Contrato',
          description: 'Contrato de seguro de bem',
          icon: 'Shield',
          content: `CONTRATO DE SEGURO

SEGURADOR: [NOME DA SEGURADORA]
SEGURADO: [NOME], [QUALIFICAÇÃO]

BEM SEGURADO: [DESCRIÇÃO]

CLÁUSULAS:

1ª - RISCO COBERTO: [ESPECIFICAÇÃO]
2ª - VALOR SEGURADO: R$ [VALOR]
3ª - PRÊMIO: R$ [VALOR] [PERIODICIDADE]
4ª - VIGÊNCIA: [PERÍODO DE COBERTURA]
5ª - FRANQUIA: R$ [VALOR]
6ª - SINISTRO: [PROCEDIMENTOS]

[LOCAL], [DATA]

_________________________________     _________________________________
SEGURADOR                             SEGURADO`
        }
      ]
    },
    {
      id: 'familia-civeis',
      name: 'Direito de Família',
      emoji: '👨‍👩‍👧‍👦',
      templates: [
        {
          id: 'acordo-divorcio',
          name: 'Acordo de divórcio',
          type: 'Acordo',
          description: 'Acordo extrajudicial de divórcio',
          icon: 'Users',
          content: `ACORDO DE DIVÓRCIO EXTRAJUDICIAL

[NOME DO MARIDO] e [NOME DA ESPOSA], casados sob o regime de [REGIME], resolvem pôr fim à sociedade conjugal mediante as seguintes condições:

1. DIVÓRCIO: Requerem o divórcio consensual

2. FILHOS:
( ) Não há filhos menores
( ) Filhos menores: [ESPECIFICAR ACORDO]

3. BENS:
[DESCRIÇÃO DA PARTILHA]

4. ALIMENTOS:
( ) Dispensam alimentos mútuos
( ) Acordo: [ESPECIFICAR]

[LOCAL], [DATA]

_________________________________     _________________________________
[NOME DO MARIDO]                      [NOME DA ESPOSA]

ADVOGADOS:
_________________________________     _________________________________
[ADVOGADO 1]                          [ADVOGADO 2]`
        },
        {
          id: 'acordo-alimentos',
          name: 'Acordo de alimentos',
          type: 'Acordo',
          description: 'Acordo extrajudicial de alimentos',
          icon: 'Baby',
          content: `ACORDO DE ALIMENTOS

ALIMENTANTE: [NOME], [QUALIFICAÇÃO]
ALIMENTANDO: [NOME DO MENOR], representado por [REPRESENTANTE]

CONDIÇÕES:

1. VALOR: [PERCENTUAL]% do salário mínimo ou R$ [VALOR]

2. VENCIMENTO: Todo dia [DIA] de cada mês

3. DESCONTO: Autorizado desconto em folha de pagamento

4. REAJUSTE: Anual, conforme índice oficial

5. EXTRAS: [ESPECIFICAR DESPESAS EXTRAS]

[LOCAL], [DATA]

_________________________________     _________________________________
ALIMENTANTE                           REPRESENTANTE LEGAL

ADVOGADOS:
_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'acordo-guarda',
          name: 'Acordo de guarda e visitas',
          type: 'Acordo',
          description: 'Regulamentação de guarda e visitas',
          icon: 'Shield',
          content: `ACORDO DE GUARDA E VISITAS

GENITORES:
PAI: [NOME], [QUALIFICAÇÃO]
MÃE: [NOME], [QUALIFICAÇÃO]

FILHO(A): [NOME], [IDADE] anos

CONDIÇÕES:

1. GUARDA: [TIPO DE GUARDA]

2. RESPONSÁVEL PELA GUARDA: [NOME]

3. REGIME DE VISITAS:
- Finais de semana alternados
- Feriados: [ACORDO]
- Férias escolares: [DIVISÃO]

4. PENSÃO ALIMENTÍCIA: [VALOR E CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
PAI                                   MÃE`
        },
        {
          id: 'acordo-separacao',
          name: 'Acordo de separação',
          type: 'Acordo',
          description: 'Acordo de separação judicial',
          icon: 'UserMinus',
          content: `ACORDO DE SEPARAÇÃO JUDICIAL

[NOME DO MARIDO] e [NOME DA ESPOSA] acordam sua separação judicial:

CONDIÇÕES:

1. SEPARAÇÃO: Consensual, sem culpa

2. PARTILHA DE BENS:
[DESCRIÇÃO DETALHADA]

3. GUARDA DOS FILHOS:
[ACORDO SOBRE GUARDA]

4. PENSÃO ALIMENTÍCIA:
Para os filhos: R$ [VALOR]
Entre cônjuges: [DISPENSAM/VALOR]

5. NOME: [MANUTENÇÃO/ALTERAÇÃO]

[LOCAL], [DATA]

_________________________________     _________________________________
MARIDO                                ESPOSA`
        },
        {
          id: 'escritura-pacto-antenupcial',
          name: 'Pacto antenupcial',
          type: 'Pacto',
          description: 'Acordo pré-matrimonial sobre bens',
          icon: 'FileHeart',
          content: `ESCRITURA PÚBLICA DE PACTO ANTENUPCIAL

CONTRAENTES:
NOIVO: [NOME], [QUALIFICAÇÃO]
NOIVA: [NOME], [QUALIFICAÇÃO]

REGIME DE BENS ESCOLHIDO: [REGIME]

CLÁUSULAS ESPECIAIS:
[CONDIÇÕES ESPECÍFICAS]

BENS PARTICULARES:
Do noivo: [RELAÇÃO]
Da noiva: [RELAÇÃO]

Por estarem justos e acordados, assinam:

[LOCAL], [DATA]

_________________________________     _________________________________
NOIVO                                 NOIVA

TABELIÃO: [NOME]`
        },
        {
          id: 'termo-guarda-compartilhada',
          name: 'Termo de guarda compartilhada',
          type: 'Termo',
          description: 'Acordo de guarda compartilhada',
          icon: 'Users',
          content: `TERMO DE GUARDA COMPARTILHADA

GENITORES:
PAI: [NOME], [QUALIFICAÇÃO]
MÃE: [NOME], [QUALIFICAÇÃO]

MENOR: [NOME], [IDADE] anos

CONDIÇÕES DA GUARDA COMPARTILHADA:

1. RESIDÊNCIA: [DEFINIÇÃO DE RESIDÊNCIA]
2. TEMPO DE CONVIVÊNCIA: [DISTRIBUIÇÃO]
3. DECISÕES: Tomadas em conjunto
4. EDUCAÇÃO: [RESPONSABILIDADES]
5. SAÚDE: [RESPONSABILIDADES]
6. DESPESAS: [DIVISÃO DOS CUSTOS]

[LOCAL], [DATA]

_________________________________     _________________________________
PAI                                   MÃE`
        },
        {
          id: 'reconhecimento-paternidade',
          name: 'Termo de reconhecimento de paternidade',
          type: 'Reconhecimento',
          description: 'Reconhecimento voluntário de paternidade',
          icon: 'Baby',
          content: `TERMO DE RECONHECIMENTO DE PATERNIDADE

Eu, [NOME DO PAI], [QUALIFICAÇÃO], RECONHEÇO como meu filho(a) [NOME DO MENOR], nascido(a) em [DATA], filho(a) de [NOME DA MÃE].

DADOS DO MENOR:
Nome: [NOME COMPLETO]
Data de nascimento: [DATA]
Local: [CIDADE/ESTADO]
Registro: [CARTÓRIO]

EFEITOS:
- Inclusão do nome paterno
- Direito a alimentos
- Direito sucessório
- Uso do nome de família

[LOCAL], [DATA]

_________________________________
[NOME DO PAI]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]`
        }
      ]
    },
    {
      id: 'direito-imobiliario',
      name: 'Direito Imobiliário',
      emoji: '🏠',
      templates: [
        {
          id: 'escritura-compra-venda-imovel',
          name: 'Escritura de compra e venda de imóvel',
          type: 'Escritura',
          description: 'Compra e venda de bem imóvel',
          icon: 'Home',
          content: `ESCRITURA PÚBLICA DE COMPRA E VENDA

VENDEDOR: [NOME], [QUALIFICAÇÃO]
COMPRADOR: [NOME], [QUALIFICAÇÃO]

IMÓVEL:
[DESCRIÇÃO COMPLETA COM CONFRONTAÇÕES]
Matrícula nº [NÚMERO] do [CRI]

PREÇO: R$ [VALOR]

CLÁUSULAS:

1ª - O VENDEDOR é legítimo proprietário
2ª - O COMPRADOR paga o preço ajustado
3ª - Ficam transferidos todos os direitos
4ª - O imóvel está livre de ônus
5ª - Impostos por conta do COMPRADOR

[LOCAL], [DATA]

_________________________________
VENDEDOR

_________________________________
COMPRADOR

TABELIÃO: [NOME]`
        },
        {
          id: 'contrato-promessa-compra-venda',
          name: 'Promessa de compra e venda',
          type: 'Promessa',
          description: 'Compromisso de compra e venda futura',
          icon: 'FileContract',
          content: `CONTRATO DE PROMESSA DE COMPRA E VENDA

PROMITENTE VENDEDOR: [NOME], [QUALIFICAÇÃO]
PROMITENTE COMPRADOR: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [DESCRIÇÃO]

CONDIÇÕES:

1ª - PREÇO TOTAL: R$ [VALOR]
2ª - ENTRADA: R$ [VALOR] (pago neste ato)
3ª - SALDO: R$ [VALOR] em [PARCELAS]
4ª - JUROS: [TAXA]% ao ano
5ª - ENTREGA: [PRAZO]
6ª - ESCRITURA: Após quitação integral

[LOCAL], [DATA]

_________________________________     _________________________________
PROMITENTE VENDEDOR                   PROMITENTE COMPRADOR`
        },
        {
          id: 'contrato-incorporacao',
          name: 'Contrato de incorporação imobiliária',
          type: 'Incorporação',
          description: 'Contrato de venda de unidade na planta',
          icon: 'Building2',
          content: `CONTRATO DE INCORPORAÇÃO IMOBILIÁRIA

INCORPORADORA: [NOME DA EMPRESA]
ADQUIRENTE: [NOME], [QUALIFICAÇÃO]

EMPREENDIMENTO: [NOME DO EMPREENDIMENTO]
UNIDADE: [NÚMERO/DESCRIÇÃO]

CONDIÇÕES:

1ª - ÁREA PRIVATIVA: [METRAGEM]
2ª - ÁREA COMUM: [METRAGEM]
3ª - PREÇO: R$ [VALOR]
4ª - FORMA DE PAGAMENTO: [CONDIÇÕES]
5ª - PRAZO DE ENTREGA: [DATA]
6ª - FINANCIAMENTO: [CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
INCORPORADORA                         ADQUIRENTE`
        },
        {
          id: 'contrato-permuta',
          name: 'Contrato de permuta de imóveis',
          type: 'Permuta',
          description: 'Troca de imóveis entre proprietários',
          icon: 'ArrowLeftRight',
          content: `CONTRATO DE PERMUTA DE IMÓVEIS

PERMUTANTE 1: [NOME], [QUALIFICAÇÃO]
PERMUTANTE 2: [NOME], [QUALIFICAÇÃO]

IMÓVEL 1: [DESCRIÇÃO COMPLETA]
Valor: R$ [VALOR]

IMÓVEL 2: [DESCRIÇÃO COMPLETA]
Valor: R$ [VALOR]

CONDIÇÕES:

1ª - TROCA: Direta dos imóveis descritos
2ª - DIFERENÇA: R$ [VALOR] (se houver)
3ª - ESCRITURAS: Simultâneas
4ª - IMPOSTOS: Por conta de cada permutante

[LOCAL], [DATA]

_________________________________     _________________________________
PERMUTANTE 1                          PERMUTANTE 2`
        },
        {
          id: 'contrato-corretagem',
          name: 'Contrato de corretagem imobiliária',
          type: 'Corretagem',
          description: 'Prestação de serviços de corretagem',
          icon: 'UserCheck',
          content: `CONTRATO DE CORRETAGEM IMOBILIÁRIA

CORRETOR: [NOME], CRECI [NÚMERO]
CLIENTE: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [DESCRIÇÃO]

CONDIÇÕES:

1ª - SERVIÇO: Intermediação para [VENDA/LOCAÇÃO]
2ª - PRAZO: [PERÍODO DE EXCLUSIVIDADE]
3ª - PREÇO: R$ [VALOR]
4ª - COMISSÃO: [PERCENTUAL]% sobre o valor
5ª - PROPAGANDA: Por conta do corretor
6ª - EXCLUSIVIDADE: [SIM/NÃO]

[LOCAL], [DATA]

_________________________________     _________________________________
CORRETOR                              CLIENTE`
        },
        {
          id: 'escritura-doacao-imovel',
          name: 'Escritura de doação de imóvel',
          type: 'Doação',
          description: 'Doação gratuita de bem imóvel',
          icon: 'Gift',
          content: `ESCRITURA PÚBLICA DE DOAÇÃO DE IMÓVEL

DOADOR: [NOME], [QUALIFICAÇÃO]
DONATÁRIO: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [DESCRIÇÃO COMPLETA]
Matrícula: [NÚMERO] do [CRI]

CONDIÇÕES:

1ª - DOAÇÃO: Pura e simples
2ª - ACEITAÇÃO: Pelo donatário
3ª - TRANSFERÊNCIA: Imediata
4ª - IMPOSTOS: Por conta do donatário
5ª - CLÁUSULA ESPECIAL: [SE HOUVER]

[LOCAL], [DATA]

_________________________________
DOADOR

_________________________________
DONATÁRIO

TABELIÃO: [NOME]`
        },
        {
          id: 'contrato-administracao-imovel',
          name: 'Contrato de administração de imóvel',
          type: 'Administração',
          description: 'Administração de bens imóveis',
          icon: 'Settings',
          content: `CONTRATO DE ADMINISTRAÇÃO DE IMÓVEL

PROPRIETÁRIO: [NOME], [QUALIFICAÇÃO]
ADMINISTRADOR: [NOME/EMPRESA]

IMÓVEL: [DESCRIÇÃO]

SERVIÇOS:

1º - LOCAÇÃO: Busca de inquilinos
2º - COBRANÇA: Aluguéis e encargos
3º - MANUTENÇÃO: Pequenos reparos
4º - VISTORIA: Periódica do imóvel
5º - PRESTAÇÃO DE CONTAS: Mensal

REMUNERAÇÃO: [PERCENTUAL]% dos aluguéis

[LOCAL], [DATA]

_________________________________     _________________________________
PROPRIETÁRIO                          ADMINISTRADOR`
        },
        {
          id: 'escritura-hipoteca',
          name: 'Escritura de hipoteca',
          type: 'Hipoteca',
          description: 'Constituição de garantia hipotecária',
          icon: 'Lock',
          content: `ESCRITURA PÚBLICA DE HIPOTECA

DEVEDOR/HIPOTECANTE: [NOME], [QUALIFICAÇÃO]
CREDOR/HIPOTECÁRIO: [NOME], [QUALIFICAÇÃO]

DÍVIDA GARANTIDA: R$ [VALOR]
ORIGEM: [DESCRIÇÃO DA DÍVIDA]

IMÓVEL HIPOTECADO:
[DESCRIÇÃO COMPLETA]
Matrícula: [NÚMERO]

CONDIÇÕES:

1ª - GARANTIA: Hipoteca de 1º grau
2ª - VENCIMENTO: [DATA]
3ª - JUROS: [TAXA]% ao ano
4ª - EXECUÇÃO: Pela dívida total

[LOCAL], [DATA]

_________________________________     _________________________________
HIPOTECANTE                           HIPOTECÁRIO

TABELIÃO: [NOME]`
        }
      ]
    },
    {
      id: 'outros-civeis',
      name: 'Outros Documentos',
      emoji: '📄',
      templates: [
        {
          id: 'declaracao-uniao-estavel',
          name: 'Declaração de união estável',
          type: 'Declaração',
          description: 'Declaração de convivência em união estável',
          icon: 'Heart',
          content: `DECLARAÇÃO DE UNIÃO ESTÁVEL

[NOME 1], [QUALIFICAÇÃO] e [NOME 2], [QUALIFICAÇÃO], DECLARAM que mantêm união estável desde [DATA].

CARACTERÍSTICAS DA UNIÃO:
- Convivência pública, contínua e duradoura
- Objetivo de constituir família
- Residência comum: [ENDEREÇO]

REGIME DE BENS: [ESPECIFICAR]

Por ser verdade, firmam a presente.

[LOCAL], [DATA]

_________________________________     _________________________________
[NOME 1]                              [NOME 2]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]`
        },
        {
          id: 'testamento',
          name: 'Testamento particular',
          type: 'Testamento',
          description: 'Testamento escrito pelo próprio testador',
          icon: 'Scroll',
          content: `TESTAMENTO PARTICULAR

Eu, [NOME DO TESTADOR], [QUALIFICAÇÃO], no gozo de minhas faculdades mentais, faço este testamento:

1. REVOGAÇÃO: Revogo disposições testamentárias anteriores

2. HERDEIROS NECESSÁRIOS:
[RELAÇÃO DOS HERDEIROS]

3. DISPOSIÇÕES:
[DISPOSIÇÕES ESPECÍFICAS SOBRE BENS]

4. LEGADOS:
[ESPECIFICAR LEGADOS, SE HOUVER]

5. EXECUTORES:
Nomeio como executor(es): [NOME(S)]

Por ser minha última vontade, assino este testamento.

[LOCAL], [DATA]

_________________________________
[NOME DO TESTADOR]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]
3. [NOME], [QUALIFICAÇÃO]`
        },
        {
          id: 'escritura-compra-venda-imovel',
          name: 'Escritura de compra e venda de imóvel',
          type: 'Escritura',
          description: 'Compra e venda de bem imóvel',
          icon: 'Home',
          content: `ESCRITURA PÚBLICA DE COMPRA E VENDA

VENDEDOR: [NOME], [QUALIFICAÇÃO]
COMPRADOR: [NOME], [QUALIFICAÇÃO]

IMÓVEL:
[DESCRIÇÃO COMPLETA COM CONFRONTAÇÕES]
Matrícula nº [NÚMERO] do [CRI]

PREÇO: R$ [VALOR]

CLÁUSULAS:

1ª - O VENDEDOR é legítimo proprietário
2ª - O COMPRADOR paga o preço ajustado
3ª - Ficam transferidos todos os direitos
4ª - O imóvel está livre de ônus
5ª - Impostos por conta do COMPRADOR

[LOCAL], [DATA]

_________________________________
VENDEDOR

_________________________________
COMPRADOR

TABELIÃO: [NOME]`
        },
        {
          id: 'declaracao-posse',
          name: 'Declaração de posse mansa e pacífica',
          type: 'Declaração',
          description: 'Declaração de exercício de posse',
          icon: 'MapPin',
          content: `DECLARAÇÃO DE POSSE MANSA E PACÍFICA

Eu, [NOME DO DECLARANTE], [QUALIFICAÇÃO], DECLARO que exerço posse mansa, pacífica e ininterrupta sobre o imóvel:

DESCRIÇÃO DO IMÓVEL:
[ENDEREÇO E CONFRONTAÇÕES]

PERÍODO DE POSSE:
Desde: [DATA DE INÍCIO]
Tempo: [ANOS] anos

CARACTERÍSTICAS DA POSSE:
- Mansa e pacífica
- Contínua e ininterrupta
- Com animus domini
- Sem oposição de terceiros

FINALIDADE: [PARA QUE FINS]

[LOCAL], [DATA]

_________________________________
[NOME DO DECLARANTE]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]`
        },
        {
          id: 'termo-inventario-extrajudicial',
          name: 'Termo de inventário extrajudicial',
          type: 'Inventário',
          description: 'Inventário consensual em cartório',
          icon: 'FileList',
          content: `TERMO DE INVENTÁRIO EXTRAJUDICIAL

FALECIDO: [NOME], falecido em [DATA]

HERDEIROS:
[RELAÇÃO DOS HERDEIROS]

BENS DO ESPÓLIO:
[DESCRIÇÃO DOS BENS]

DÍVIDAS: [SE HOUVER]

PARTILHA:
[DESCRIÇÃO DA DIVISÃO DOS BENS]

Os herdeiros estão de acordo com a partilha proposta.

[LOCAL], [DATA]

HERDEIROS:
[ASSINATURAS]

TABELIÃO: [NOME]`
        },
        {
          id: 'escritura-enfiteuse',
          name: 'Escritura de enfiteuse',
          type: 'Enfiteuse',
          description: 'Constituição de direito real sobre imóvel',
          icon: 'Landmark',
          content: `ESCRITURA PÚBLICA DE ENFITEUSE

SENHORIO DIRETO: [NOME], [QUALIFICAÇÃO]
ENFITEUTA: [NOME], [QUALIFICAÇÃO]

IMÓVEL: [DESCRIÇÃO COMPLETA]

CONDIÇÕES:

1ª - PRAZO: [PRAZO OU PERPÉTUA]
2ª - FORO ANUAL: R$ [VALOR]
3ª - LAUDÊMIO: [PERCENTUAL]% nas alienações
4ª - BENFEITORIAS: [CONDIÇÕES]
5ª - TRANSFERÊNCIA: [CONDIÇÕES]

[LOCAL], [DATA]

_________________________________     _________________________________
SENHORIO DIRETO                       ENFITEUTA

TABELIÃO: [NOME]`
        },
        {
          id: 'contrato-sociedade-simples',
          name: 'Contrato social de sociedade simples',
          type: 'Sociedade',
          description: 'Constituição de sociedade simples',
          icon: 'Users',
          content: `CONTRATO SOCIAL DE SOCIEDADE SIMPLES

SÓCIOS:
SÓCIO 1: [NOME], [QUALIFICAÇÃO]
SÓCIO 2: [NOME], [QUALIFICAÇÃO]

DENOMINAÇÃO: [NOME DA SOCIEDADE]

CLÁUSULAS:

1ª - OBJETO SOCIAL: [ATIVIDADE]
2ª - SEDE: [ENDEREÇO]
3ª - CAPITAL SOCIAL: R$ [VALOR]
4ª - QUOTAS: [PARTICIPAÇÃO DE CADA SÓCIO]
5ª - ADMINISTRAÇÃO: [DEFINIÇÃO]
6ª - EXERCÍCIO SOCIAL: [PERÍODO]

[LOCAL], [DATA]

_________________________________     _________________________________
SÓCIO 1                               SÓCIO 2`
        }
      ]
    }
  ]
};
